import { lazyWithRetry } from "../utils/lazyWithRetry";
import AdminLayout         from "../layouts/AdminLayout";
import ProtectedRoute      from "../components/common/ProtectedRoute";

const Dashboard           = lazyWithRetry(() => import("../pages/admin/Dashboard"));
const PendingReservations = lazyWithRetry(() => import("../pages/admin/PendingReservations"));
const ApprovedBookings    = lazyWithRetry(() => import("../pages/admin/ApprovedBookings"));
const ManageBookings      = lazyWithRetry(() => import("../pages/admin/ManageBookings"));
const SportsSetup         = lazyWithRetry(() => import("../pages/admin/SportsSetup"));
const FacilitySetup       = lazyWithRetry(() => import("../pages/admin/FacilitySetup"));
const BlogSetup           = lazyWithRetry(() => import("../pages/admin/BlogSetup"));
const GallerySetup        = lazyWithRetry(() => import("../pages/admin/GalleryAdmin"));
const PromotionsSetup     = lazyWithRetry(() => import("../pages/admin/PromotionsSetup"));
const ReviewsSetup        = lazyWithRetry(() => import("../pages/admin/Reviewssetup"));
const EventsAdmin         = lazyWithRetry(() => import("../pages/admin/EventsAdmin"));
const HolidaysSetup       = lazyWithRetry(() => import("../pages/admin/HolidaysSetup"));
const HomeFacilitySetup   = lazyWithRetry(() => import("../pages/admin/HomeFacilitySetup"));

const adminRoutes = {
  path: "admin-dashboard",
  element: (
    <ProtectedRoute>
      <AdminLayout />
    </ProtectedRoute>
  ),
  children: [
    { index: true,                        element: <Dashboard /> },
    { path: "reservationadmin",           element: <PendingReservations /> },
    { path: "approvedbookings",           element: <ApprovedBookings /> },
    { path: "managebookings",             element: <ManageBookings /> },
    { path: "sportssetup",                element: <SportsSetup /> },
    { path: "facilitysetup",              element: <FacilitySetup /> },
    { path: "facilitysetup/:facilityId",  element: <FacilitySetup /> },
    { path: "blog",                       element: <BlogSetup /> },
    { path: "gallery",                    element: <GallerySetup /> },
    { path: "promotions",                 element: <PromotionsSetup /> },
    { path: "reviews",                    element: <ReviewsSetup /> },
    { path: "events",                     element: <EventsAdmin /> },
    { path: "holidays",                   element: <HolidaysSetup /> },
    { path: "home-facilities",            element: <HomeFacilitySetup /> },
  ],
};

export default adminRoutes;